import { ForwardTradeRecsAssignModalProps } from "./forward-trade-recs-assign-modal.types";
import { ForwardTradeRecsAssignModalView } from "./forward-trade-recs-assign-modal-view";
import { useForwardTradeRecsAssignModal } from "./use-forward-trade-recs-assign-modal";

export const ForwardTradeRecsAssignModal = (props: ForwardTradeRecsAssignModalProps) => {
  const logic = useForwardTradeRecsAssignModal(props);
  return <ForwardTradeRecsAssignModalView {...logic} />;
};
